import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const WarningIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M12 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z M12.885 1.534a1 1 0 0 0-1.77 0l-10 19A1 1 0 0 0 2 22h20a1 1 0 0 0 .885-1.466l-10-19ZM2 21 12 2l10 19H2Z"
    />
  </IconWrapper>
)

export default WarningIconMedium
